export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export const randomUUID = (): string => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');

  return [
    hex.substring(0, 8),
    hex.substring(8, 12),
    hex.substring(12, 16),
    hex.substring(16, 20),
    hex.substring(20),
  ].join('-');
};

const UUID_REGEXP = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;

export const isValidUUID = (uuid: string | undefined | null): uuid is string =>
  typeof uuid === 'string' && UUID_REGEXP.test(uuid) && uuid !== NIL_UUID;

export const isDefaultUUID = (uuid: string | undefined | null): boolean => uuid === NIL_UUID;
